<template>
  <div>
    <div v-if="!mobileView" id="mySidenav" class="sidenav bg-white " @mouseenter="hoverIs()" @mouseleave="hoverOut()">
      <div >
        <div
          class="d_icon_box items-center hover:bg-blue-100 "
          v-for="item in routesList"
          :key="item.path"
          @click="routeTo(item.name)"  :class="item.meta.selected ? 'border-l-4 shadow-sm border-primary bg-blue-50 transition delay-150 text-primary' : ''"
        >
          <div class="d_icon_child" >
            <div class="p-3 rounded ">
              <component :is="item.meta.routeIcon" v-bind="item.meta.routIconSize"></component>
            </div>
          </div>
          <span class="d_items_text">{{ item.meta.title }}</span>
        </div>
      </div>
    </div>
    <div v-else class="sv_sidenav_box">
      <div id="sv_smySidenav" class="sv_sidenav bg-white" v-click-outside="hoverOut">
        <div
          class="d_icon_box items-center hover:bg-blue-100 "
          v-for="item in routesList"
          :key="item.path"
          @click="routeTo(item.name)"  :class="item.meta.selected ? 'border-l-4 shadow-sm border-primary bg-blue-50 transition delay-150 text-primary' : ''"
        >
          <div class="d_icon_child" >
            <div class="p-3 rounded ">
              <component :is="item.meta.routeIcon" v-bind="item.meta.routIconSize"></component>
            </div>
          </div>
          <span class="d_items_text">{{ item.meta.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {removeCookies} from '@/utils/cookies'
import { getCookies } from "@/utils/cookies";
import dashboardSvg from '@/assets/images/svg/dashboardSvg.vue'
import userSidebar from '@/assets/images/svg/userSidebar.vue'
import deviceSidebar from '@/assets/images/svg/deviceSidebar.vue'
import customerSide from '@/assets/images/svg/customerSide.vue'
import leadSide from '@/assets/images/svg/leadSide.vue'
import orgSideIcon from '@/assets/images/svg/orgSideIcon.vue';
import SupportSvg from '@/assets/images/svg/supportSvg.vue';
import feedbackSvg from '@/assets/images/svg/feedbackSvg.vue';
import ActivityIcon from '@/assets/images/svg/activityIcon.vue';
import SettingSvg from '@/assets/images/svg/settingSvg.vue';
import colors from '@/assets/colors.json'
import router from '@/router/index.js'
export default {
  components: {
    feedbackSvg,
    ActivityIcon,
    SupportSvg,
    SettingSvg,
    orgSideIcon,
    userSidebar,
    deviceSidebar,
    leadSide,
    customerSide,
    dashboardSvg,
  },
  name: "leftNavbar",
  props: ["routesList"],
  data() {
    return {
      userDetail: {},
      mobileView: false,
      toutInfo: null,
      drawerOpen: false,
      extraSmall: false,
      drawerIsOpen: false,
      showMenuContinue: true
    };
  },
  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
  },
  watch: {
    routesList: {
      handler () {
        this.setNavigation(this.$route.meta.loadPage)
      }
    }
  },
  mounted() {
    this.$root.$on('openDialog', () => {
      console.log('click click')
      this.hoverIs()
    })
    this.resizeWindowHandler();
    if (getCookies("lockDrawer") === "draweLocked" && !this.mobileView) {
      this.drawerIsOpen = true;
    } else {
      this.drawerIsOpen = false;
    }
    router.afterEach(() => {
      setTimeout(() => {
        this.setNavigation(this.$route.meta.loadPage)
      }, 100);
    })
    let userData = localStorage.getItem("employeeData1");
    this.userDetail = JSON.parse(userData);
  },
  methods: {
    hoverIs () {
      if (!this.mobileView) {
        document.getElementById("mySidenav").style.minWidth = "250px";
        document.getElementById("mySidenav").style.maxWidth = "250px";
        document.getElementById("mySidenav").style.boxShadow = "2px 0px 23px -6px rgba(128,128,128,0.52)";
      } else {
        document.getElementById("sv_smySidenav").style.minWidth = "250px";
        document.getElementById("sv_smySidenav").style.maxWidth = "250px";
        document.getElementById("sv_smySidenav").style.boxShadow = "2px 0px 23px -6px rgba(128,128,128,0.52)";
      }
    },
    hoverOut () {
      if (!this.mobileView) {
        document.getElementById("mySidenav").style.minWidth = "80px";
        document.getElementById("mySidenav").style.maxWidth = "80px";
        document.getElementById("mySidenav").style.boxShadow = null;
      } else {
        document.getElementById("sv_smySidenav").style.minWidth = "0px";
        document.getElementById("sv_smySidenav").style.maxWidth = "0px";
        document.getElementById("sv_smySidenav").style.boxShadow = null;
      }
    },
    LogOut () {
      removeCookies('saToken')
      localStorage.clear()
      this.$store.dispatch('GetEmployeePermission', true)
      this.$router.push({name: 'login'})
      location.reload()
    },
    setNavigation (value) {
      for (let index = 0; index < this.routesList.length; index++) {
        if (value === this.routesList[index].meta.loadPage) {
          this.routesList[index].meta.selected = true;
          this.routesList[index].meta.routIconSize.color = colors.primary;
        } else {
          this.routesList[index].meta.selected = false;
          this.routesList[index].meta.routIconSize.color = colors.text2;
        }
      }
    },
    routeTo(path) {
      console.log('path', path)
      console.log('check11', this.$route)
      console.log('$routesList', this.routesList)
      this.$router.push({ name: path })
      for (let index = 0; index < this.routesList.length; index++) {
        if (this.$route.meta.loadPage === this.routesList[index].meta.loadPage) {
          this.routesList[index].meta.selected = true;
          this.routesList[index].meta.routIconSize.color = colors.primary;
        } else {
          this.routesList[index].meta.selected = false;
          this.routesList[index].meta.routIconSize.color = colors.text2;
        }
      }
    },
    closeDrawer() {
      this.showMenuContinue = false
        // console.log('check 11', getCookies("lockDrawer"))
      document.getElementById("overlay").style.display = "none";
      if (getCookies("lockDrawer") === "draweUnLocked" || getCookies("lockDrawer") === null) {
        document.getElementById("myTopnav").style.left = "80px";
        document.getElementById("mySidenav").style.minWidth = "80px";
        this.drawerIsOpen = false;
      }
      setTimeout(() => {
        this.showMenuContinue = true
      }, 600);
    },
    openDrawer() {
      // console.log('check 10', this.showMenuContinue)
      setTimeout(() => {
        if (this.showMenuContinue) {
          document.getElementById("mySidenav").style.minWidth = "260px";
          document.getElementById("menu_items_box").style.left = "275px";
          if (getCookies("lockDrawer") === "draweUnLocked") {
            // document.getElementById('myTopnav').style.left = '248px'
            this.showDashboadMenus = false;
            this.showHistory = false;
            this.showAddFavorite = false;
            this.showAvtarMenu = false;
            this.$root.$emit('closeCardPopUp', true)
          }
          this.drawerIsOpen = true;
        }
      }, 400);
    },
    resizeWindowHandler() {
      if (window.innerWidth < 1024) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
      if (window.innerWidth < 600) {
        this.extraSmall = true;
      } else {
        this.extraSmall = false;
      }
    },
  },
};
</script>
<style scoped>
</style>
